/**
 * Defaults for nav / chrome icons.
 * Tabler: pass `{ ...WP_ICON_NAV }` (stroke). mx-icons Twotone: use `size` + `color: currentColor`.
 * NavCluster sizes glyphs via `--wp-nav-icon-size` (1em → matches body type).
 */
export const WP_ICON_STROKE = 1.5 as const;

export const WP_ICON_NAV = { size: 16, stroke: WP_ICON_STROKE } as const;
/** Header nav triggers on narrow viewports (44px touch targets). */
export const WP_ICON_NAV_MOBILE = { size: 22, stroke: WP_ICON_STROKE } as const;
/** Sort / filter / search toggles in DataTable column headers */
export const WP_ICON_DATATABLE_TH_ACTION = { size: 14, stroke: WP_ICON_STROKE } as const;
export const WP_ICON_HEADER = { size: 18, stroke: WP_ICON_STROKE } as const;
export const WP_ICON_BUTTON = { size: 18, stroke: WP_ICON_STROKE } as const;
